import React, { useEffect } from 'react';

export default function Projects() {
  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = 'https://www.ceylonext.com/projects';
    document.title = 'Projects | CeyloNext';
  }, []);

  return (
    <main className="main-content">
      <div className="hero-text">
        <h1>PROJECTS</h1>
        <p>This is where your projects portfolio will go.</p>
      </div>
    </main>
  );
}